import { Alert } from "@vinomofo/components";

interface ToastProps {
  label?: string;
  message?: string;
}

export const SuccessToast = ({
  label = "Success!",
  message = "",
}: ToastProps): JSX.Element => {
  return (
    <Alert
      padding={1}
      px={1}
      boxShadow="none"
      intent="success"
      label={label}
      message={message}
    />
  );
};
